import { ChangeDetectionStrategy, Component, computed, input, output, signal } from "@angular/core";
import { RouterLink } from "@angular/router";

import { SvgIconComponent } from "angular-svg-icon";

import { LoginRoutesConstants } from "@login/routes/login.routes.constants";
import { ButtonWithLoadingComponent } from "@shared/components/button-with-loading/button-with-loading.component";
import { CustomIconComponent } from "@shared/components/custom-icon/custom-icon.component";
import { CustomIconName } from "@shared/icons/icon-definitions";
import { AuthProvider } from "@shared/models/types.model";

interface AuthButton {
  name: string;
  iconName: CustomIconName;
  provider: AuthProvider;
}

@Component({
  selector: "component-base-login",
  templateUrl: "./base-login.component.html",
  styleUrls: ["./base-login.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonWithLoadingComponent, CustomIconComponent, SvgIconComponent, RouterLink]
})
export class BaseLoginComponent {
  readonly showOAuth = input<boolean>(true);
  readonly showTerms = input<boolean>(true);
  readonly headerTitle = input<string | undefined>(undefined);
  readonly headerSubtitle = input<string | undefined>(undefined);
  readonly isLoading = input<boolean>(false);
  readonly currentProvider = input<AuthProvider | null>(null);
  readonly buttonText = input<string>("Continue with");

  readonly oauthAction = output<AuthProvider>();

  protected readonly loginRoutes = LoginRoutesConstants;

  protected readonly authButtons = signal<AuthButton[]>([
    { name: "Google", iconName: "google", provider: AuthProvider.GOOGLE },
    { name: "Github", iconName: "github", provider: AuthProvider.GITHUB }
  ]);

  protected readonly authProvider = AuthProvider;

  protected readonly isButtonLoading = computed(() => (provider: AuthProvider): boolean => {
    return this.isLoading() && this.currentProvider() === provider;
  });

  protected readonly isButtonDisabled = computed(() => (provider: AuthProvider): boolean => {
    return this.isLoading() && this.currentProvider() !== provider;
  });

  protected onOAuthAction(provider: AuthProvider): void {
    this.oauthAction.emit(provider);
  }
}
